module.exports = __webpack_public_path__ + "assets/icon_play.cad00fd4.svg";